var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('thin-line-pie-chart',{attrs:{"animate":false,"percentage":_vm.row.capacity_percentage / 100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }